import { toast } from 'react-toastify';
import { Fetch } from '../services/api';

const padTo2Digits = (num) => {
    return num.toString().padStart(2, '0');
}

export const formatDate = (date, format = 103) => {
    let stringFormat = ''
    if (date === '' || date === undefined){
        return ;
    }else{
        switch  (format) {
            case 23:
            stringFormat = [
                date?.getFullYear(), 
                padTo2Digits(date?.getMonth() + 1),
                padTo2Digits(date?.getDate())
            ].join('-');
            break;
            case 103:
                stringFormat = [
                    padTo2Digits(date?.getDate()),
                    padTo2Digits(date?.getMonth() + 1),
                    date?.getFullYear()
                ].join('/');
                break;
                default:
                }
                
                return stringFormat;
            }
}

export const notify = (title, type, options = {}) => {
    toast[type](title, {
        position: options.position ?? "top-right",
        autoClose: options.autoClose ?? 2000,
        hideProgressBar: options.hideProgressBar ?? false,
        closeOnClick: options.closeOnClick ?? true,
        pauseOnHover: options.pauseOnHover ?? true,
        draggable: true,
        progress: undefined,
    });
}

export const soloDecimal = (e, elemento) => {
    const key = e.keyCode ? e.keyCode : e.which

    if (key === 8) return true
    
    if (key > 47 && key < 58) {
        if (elemento.value === "") return true
        const regexp = /.[0-9]{9}$/

        if(!(regexp.test(elemento.value))) {
            return true
        }
    }

    if (key === 46) {
        if (elemento.value === "") return false
        const regexp = /^[0-9]+$/
        console.log("s ", regexp.test(elemento.value))
        if (regexp.test(elemento.value)) {
            return true
        }
    }
    
    e.preventDefault()
}

export const formatState = (codState, nameState) => {
    let htmlrespuesta = '';
    let className = ''

    if ([4,50,51].includes(codState)) className = 'cursor-pointer bg-green-500 px-2 py-[2px] rounded  text-[11px] font-bold'
    else if ([1,3].includes(codState)) className = 'cursor-pointer bg-blue-500 px-2 py-[2px] rounded  text-[11px] font-bold'
    else if ([5,6,2].includes(codState)) className = 'cursor-pointer bg-red-500 px-2 py-[2px] rounded  text-[11px] font-bold'
    else if ([7,52].includes(codState)) className = 'cursor-pointer bg-red-800 px-2 py-[2px] rounded  text-[11px] font-bold'
    else if ([8].includes(codState)) className = 'cursor-pointer bg-black-800 px-2 py-[2px] rounded  text-[11px] font-bold'
    else if ([45,9].includes(codState)) className = 'cursor-pointer bg-yellow-600 px-2 py-[2px] rounded  text-[11px] font-bold'

    return className;
}

export const soloCelular = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{8}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const soloNumero = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{20}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const soloDNI = (event, element) => {
    const key = event.keyCode ? event.keyCode : event.which
    if (key === 8) return true
    if (key > 47 && key < 58) {
        if (element.value === "") return true
        const regexp = /.[0-9]{7}$/
        if(!(regexp.test(element.value))) {
            return true
        }
    }
    event.preventDefault()
}

export const primeraLetraMayuscula = (string) => {
    var str = string;

    str = str?.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
    });

    return str; 
}

export const todoMayuscula = (string)=> {
    var str = string;
    str = str?.toUpperCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
    });
    return str;
}

export const quitarTildes = (str) => {
    return str?.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
} 


export const guardarFotoGrupoChat = async (fotoFile,data) => {
    const {nomCarpeta, nomSubcarpeta, nomArchivo} = data
    let imagenValida = false
    let url = ''
    let tiempo = new Date().getTime()
    const fotoData = new FormData();
    fotoData.append('archivo', fotoFile);
    const response = await Fetch({
        url:'https://miniowebapi.abexacloud.com/api/Archivo/subirArchivo?' + new URLSearchParams({
            NombreCarpeta: nomCarpeta,
            NombreSubCarpeta: `${nomSubcarpeta}/`,
            NombreArchivo: `${nomArchivo}_${tiempo}`,
        }),
        headers:{
            contentType: 'image/*'
        },
        method: 'POST',
        body : fotoData
    }); 
    // notify(response.isValid ? response.content : response.exceptions[0], response.isValid ? 'success' : 'error');
    if (response.isValid) {
        url = `https://miniowebapi.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=${nomCarpeta}&NombreImagen=${nomSubcarpeta}/${nomArchivo}_${tiempo}`;
        imagenValida = true;
    }
    return [{ isValid : imagenValida , urlImagen: url }]
}

export const obtenerExtension = (archivo) =>{
    const partes = archivo.split('.')
    if (partes.length >= 2) {
        return partes[partes.length - 1]
    } else {
        return 'Sin extension'
    }
}

export const eliminarTodasLasExtensiones = (cadena) =>{
    const extensionesPermitidas = /\.(png|jpg|jpeg|gif|docx|xls|pdf|txt|pptx)/ig
    return ((cadena.replace(extensionesPermitidas, '')).replaceAll('.','')).replaceAll(' ','_')
}

export const transformarArchivo = async (file, esUrl, asignarArchivo ) => {
    const fechaActual = new Date()
    const fechaHoraActual = fechaHoraActualArchivo()
    file.identificador = fechaActual.getTime() + file.lastModified
    console.log("ANTES");
    console.log(file.name);
    console.log(file.nombre);
    file.nombre = `${fechaHoraActual}.${obtenerExtension(file.name)}`
    console.log("DESPUÉS");
    console.log(file.name);
    console.log(file.nombre);
    file.esUrl = esUrl
    file.extension = obtenerExtension(file.name)
    asignarArchivo({tipo: 'Agregar', carga: [file] })
}

export const seleccionarArchivo = (event, asignarArchivo, esBloqueo) => {
    event.preventDefault()
    if(esBloqueo)return
    if(event.target.files.length > 0){
        const archivos = event.target.files
        for(let i = 0; i < archivos.length; i++){
            transformarArchivo(event.target.files[i], 0,asignarArchivo)
        }
    }
}

export const fechaHoraActualArchivo = () => {
    const fechaHoraActual = new Date()
    const fechaActual = fechaHoraActual.toLocaleDateString()
    const horaActual = fechaHoraActual.toLocaleTimeString()
    const respuesta = `${fechaActual.replaceAll('/','_')}_${horaActual.replaceAll(':','_')}`
    return respuesta
}

export const eventDrop = (event, asignarArchivo, estadoArrastrar, esBloqueo) => {
    if(esBloqueo)return
    event.preventDefault()
    if(event.dataTransfer.files.length > 0){
        const archivos = event.dataTransfer.files
        for(let i = 0; i < archivos.length; i++){
            transformarArchivo(event.dataTransfer.files[i], 0, asignarArchivo)
        }
    }
    estadoArrastrar(false)
    event.stopPropagation()
}

export const eventDrag = (event, estadoArrastrar,esBloqueo) => {
    if(esBloqueo)return
    event.preventDefault()
    estadoArrastrar(true)
    event.stopPropagation()
}

export const eventPaste = (event, asignarArchivo, esBloqueo) => {
    event.preventDefault()
    if(esBloqueo)return
    if(event.clipboardData.files.length > 0){
        const archivos = event.clipboardData.files
        for(let i = 0; i < archivos.length; i++){
            transformarArchivo(event.clipboardData.files[i], 0, asignarArchivo)
        }
    }
}